const hero = document.querySelector(
    '.tpl-vacancy-page-vacancies .hero-content-wrapper'
);

// Only run if hero element exists
if (hero) {
    setStickyUpper(hero);
}

const heroSection = document.querySelector('.org-vacancy-page-hero-ab');

if (heroSection) {
    const vacancyBar = heroSection.querySelector('.hero-content-wrapper-ab');
    const isTabletOrMobile = window.innerWidth < 769;

    if (vacancyBar) {
        if (isTabletOrMobile) {
            setStickyLower(vacancyBar);
        }
        else {
            setStickyUpper(vacancyBar);
        }
    }
}

function setStickyUpper(hero) {
    const placeholder = document.createElement('div');
    const originalOffset = hero.getBoundingClientRect().top + window.scrollY; // vaste startpositie
    console.log(originalOffset);

    placeholder.style.height = `${hero.offsetHeight}px`;
    placeholder.style.display = 'none';
    hero.parentNode.insertBefore(placeholder, hero);

    let isSticky = false; // voorkomt constant togglen

    window.addEventListener('scroll', () => {
        console.log(window.scrollY, isSticky)
        if (window.scrollY > originalOffset && !isSticky) {
            hero.classList.add('is-sticky');
            placeholder.style.display = 'block';
            isSticky = true;
        } else if (window.scrollY <= originalOffset && isSticky) {
            hero.classList.remove('is-sticky');
            placeholder.style.display = 'none';
            isSticky = false;
        }
    });
}

function setStickyLower(vacancyBar) {
    const specsList = vacancyBar.querySelector('.mol-specs-list:not(.mobile-sticky) li');
        if (!specsList) {
            vacancyBar.classList.add('no-specs');
        }

        let hasAnimated = false;
        let animationTimeout = null;

        const heroObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        vacancyBar.classList.add('is-fixed');
                        if (!hasAnimated) {
                            hasAnimated = true;
                            animationTimeout = setTimeout(() => {
                                vacancyBar.classList.add('is-visible');
                            }, 100);
                        }
                    } else {
                        if (animationTimeout) {
                            clearTimeout(animationTimeout);
                            animationTimeout = null;
                        }
                        vacancyBar.classList.remove('is-visible', 'is-fixed');
                        hasAnimated = false;
                    }
                });
            },
            {
                threshold: 0,
                rootMargin: '0px'
            }
        );

        const slideDownObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        vacancyBar.classList.remove('is-visible');
                    }
                });
            },
            {
                threshold: 0,
                rootMargin: '0px'
            }
        );

        const footer = document.querySelector('footer');
        if (footer) {
            const footerObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            vacancyBar.classList.remove('is-visible');
                        } else if (vacancyBar.classList.contains('is-fixed')) {
                            vacancyBar.classList.add('is-visible');
                        }
                    });
                },
                {
                    threshold: 0,
                    rootMargin: '0px'
                }
            );

            footerObserver.observe(footer);
        }

        heroObserver.observe(heroSection);
        slideDownObserver.observe(heroSection);
}